// Copyright 2022, Imprivata, Inc.  All rights reserved.

export interface ICameraFeedback {
  title: string;
  text?: string;
  cameraError: boolean;
}

export class CameraFeedback implements ICameraFeedback {
  public title: string;
  public text?: string;
  public cameraError: boolean;

  constructor(title: string, text?: string, cameraError = false) {
    this.title = title;
    this.text = text;
    this.cameraError = cameraError;
  }
}
